import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import BookApplyRel from '@/types/table/bookApplyRel';
import { BookData } from '@/api/generated/bookController';
import { BookApplyData } from '@/api/generated/bookApplyController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface BookApplyRelData extends BookApplyRel {
  book?: BookData;
  bookApply?: BookApplyData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class BookApplyRelController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<BookApplyRelData>>(
      API_CONTEXT + '/upms/bookApplyRel/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<BookApplyRelData>(
      API_CONTEXT + '/upms/bookApplyRel/view',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/bookApplyRel/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/bookApplyRel/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/bookApplyRel/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApplyRel/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApplyRel/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApplyRel/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApplyRel/deleteBatch', params, httpOptions);
  }
  static backBook(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApplyRel/backBook', params, httpOptions);
  }
  static myList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<BookApplyRelData>>(
      API_CONTEXT + '/upms/bookApplyRel/myList',
      params,
      httpOptions,
    );
  }
}
